module.exports = __webpack_public_path__ + "img/living_1_tn.892765fa.jpg";